import { TransactionCategoryModel } from 'api-hooks/transaction-category';
import * as Yup from 'yup';

export const TransactionCategoryFormSchema = () =>
  Yup.object({
    name: Yup.string().default('').required(),
  });

export type TransactionCategoryFormType = {
  name: string;
  transactionCategory?: TransactionCategoryModel;
};
